export const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
};

// Clear/delete a cookie
export const clearCookie = (name: string): void => {
  const pastDate = new Date(0).toUTCString(); // Creates "Thu, 01 Jan 1970 00:00:00 GMT"
  document.cookie = `${name}=;expires=${pastDate};path=/`;
};
